import fetch from "isomorphic-fetch";
import API_URL from "helpers/internalApiUrl";

export const requestPurchase = (data) => {
  return function (dispatch) {
    dispatch(purchaseRequested());

    return fetch(`${API_URL}/used/purchase`, {
      method: "POST",
      //mode: 'no-cors',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: data }),
    })
      .then((response) => response.json())
      .then((json) => dispatch(receivePurchaseConfirmation(json)));
  };
};

export const purchaseRequested = () => ({ type: "PURCHASE_REQUESTED" });

export const receivePurchaseConfirmation = (response) => ({
  type: "PURCHASE_CONFIRMED",
  data: response.data,
});
